(function ($) {
	// On Dom Ready
	$(function () {
		var filters_data = {};

		$(".services-filters a.btn-sharp").on("click", function (e) {
			e.preventDefault();
			$(".services-filters a.btn-sharp").removeClass("active");
			$(this).addClass("active");

			const service_category = $(this).data("service_category");
			const service_category_title = $(this).data("service_category_title");

			if (service_category) {
				filters_data.service_category = service_category;
				// update page title
				$(".service-category-title").html(`For ${service_category_title}`);
				$(".service-category-title").show();

				// show the selected category posts only
				$(".services-list-wrapper .the-accordion").hide();
				$(".services-list-wrapper .the-accordion." + service_category).show();
			} else {
				delete filters_data.service_category;
				$(".service-category-title").html("");
				$(".service-category-title").hide();
				$(".services-list-wrapper .the-accordion").show();
			}

			// generate url & update it
			var url = new URL($("#base_url").val());
			window.history.replaceState({}, "", url.href);

			if (Object.keys(filters_data).length > 0) {
				// loop through each filter
				for (const [key, value] of Object.entries(filters_data)) {
					url.searchParams.set(key, value);
				}

				window.history.replaceState({}, "", url.href);
			}
		});
	});
})(jQuery);
